import React, { useState } from 'react';
import { Layout, Menu, Typography, Button, Card, List, Avatar, Row, Col, Statistic } from 'antd';
import {
  DashboardOutlined,
  ShoppingOutlined,
  TransactionOutlined,
  TeamOutlined,
  SettingOutlined,
  PlusOutlined,
  DollarOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;

const VendorDashboard = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  // Sample data for demonstration
  const products = [
    { id: 1, name: 'AI Chatbot API', price: 99, status: 'Active' },
    { id: 2, name: 'Fraud Detection Model', price: 199, status: 'Active' },
    { id: 3, name: 'Medical Diagnosis AI', price: 299, status: 'Pending' },
  ];

  const transactions = [
    { id: 1, product: 'AI Chatbot API', amount: 99, date: '2025-03-01' },
    { id: 2, product: 'Fraud Detection Model', amount: 199, date: '2025-03-02' },
  ];

  const recentActivities = [
    { id: 1, action: 'Added new product: AI Chatbot API', date: '2025-03-01 10:00' },
    { id: 2, action: 'Updated pricing for Fraud Detection Model', date: '2025-03-02 14:30' },
  ];

  const handleMenuClick = (e) => {
    switch (e.key) {
      case 'dashboard':
        navigate('/vendor/dashboard');
        break;
      case 'products':
        navigate('/vendor/products'); // Placeholder route
        break;
      case 'transactions':
        navigate('/vendor/transactions'); // Placeholder route
        break;
      case 'partnerships':
        navigate('/vendor/partnerships'); // Placeholder route
        break;
      case 'settings':
        navigate('/vendor/settings'); // Placeholder route
        break;
      default:
        break;
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Left Sidebar */}
      <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
        <div style={{ height: 32, margin: 16, background: 'rgba(255, 255, 255, 0.2)' }} /> {/* Logo placeholder */}
        <Menu
          theme="dark"
          defaultSelectedKeys={['dashboard']}
          mode="inline"
          onClick={handleMenuClick}
        >
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            Dashboard
          </Menu.Item>
          <Menu.Item key="products" icon={<ShoppingOutlined />}>
            Products
          </Menu.Item>
          <Menu.Item key="transactions" icon={<TransactionOutlined />}>
            Transactions
          </Menu.Item>
          <Menu.Item key="partnerships" icon={<TeamOutlined />}>
            Partnerships
          </Menu.Item>
          <Menu.Item key="settings" icon={<SettingOutlined />}>
            Settings
          </Menu.Item>
        </Menu>
      </Sider>

      {/* Main Layout */}
      <Layout className="site-layout">
        {/* Header */}
        <Header style={{ padding: '0 20px', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Title level={3} style={{ margin: 0 }}>
            Vendor Dashboard
          </Title>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/vendor/products/new')}>
            Add New Product
          </Button>
        </Header>

        {/* Content */}
        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
          <Row gutter={[16, 16]}>
            {/* Overview Stats */}
            <Col span={24}>
              <Row gutter={16}>
                <Col span={8}>
                  <Statistic title="Total Products" value={products.length} prefix={<ShoppingOutlined />} />
                </Col>
                <Col span={8}>
                  <Statistic title="Total Earnings" value={transactions.reduce((sum, t) => sum + t.amount, 0)} prefix={<DollarOutlined />} />
                </Col>
                <Col span={8}>
                  <Statistic title="Pending Approvals" value={products.filter(p => p.status === 'Pending').length} prefix={<FileTextOutlined />} />
                </Col>
              </Row>
            </Col>

            {/* Products List */}
            <Col span={16}>
              <Card title="Your Products" bordered={false}>
                <List
                  itemLayout="horizontal"
                  dataSource={products}
                  renderItem={(item) => (
                    <List.Item
                      actions={[
                        <Button type="link" onClick={() => navigate(`/vendor/products/edit/${item.id}`)}>
                          Edit
                        </Button>,
                      ]}
                    >
                      <List.Item.Meta
                        avatar={<Avatar icon={<ShoppingOutlined />} />}
                        title={item.name}
                        description={`Price: $${item.price} | Status: ${item.status}`}
                      />
                    </List.Item>
                  )}
                />
              </Card>
            </Col>

            {/* Right Sidebar */}
            <Col span={8}>
              <Card title="Recent Transactions" bordered={false} style={{ marginBottom: 16 }}>
                <List
                  dataSource={transactions}
                  renderItem={(item) => (
                    <List.Item>
                      <Text>{`${item.product} - $${item.amount} on ${item.date}`}</Text>
                    </List.Item>
                  )}
                />
              </Card>
              <Card title="Recent Activities" bordered={false}>
                <List
                  dataSource={recentActivities}
                  renderItem={(item) => (
                    <List.Item>
                      <Text>{`${item.action} at ${item.date}`}</Text>
                    </List.Item>
                  )}
                />
              </Card>
            </Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  );
};

export default VendorDashboard;